define('presentation/settings/liveReceptionistScripts/viewModels/associateLiveReceptionistScriptViewModel',[
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'constants/liveReceptionistScriptTypeConstants',
    'presentation/common/window/windowControl',
    'businessServices/state/modelStateObserver',
    'presentation/settings/liveReceptionistScripts/facades/associateLiveReceptionistScriptFacade',
    'presentation/settings/liveReceptionistScripts/validators/associateLiveReceptionistScriptViewModelValidator',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const LiveReceptionistScriptTypeConstants = require('constants/liveReceptionistScriptTypeConstants');
        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('businessServices/router/router');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _windowControl = require('presentation/common/window/windowControl');

        let _facade = null;
        let _validator = null;

        const _associateLiveReceptionistScript = () => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _facade.associateLiveReceptionistScript(self.portalScriptId(), self.selectedType())
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        self.modelStateObserver = null;
        self.liveReceptionistScriptsUrl = _navigationConfiguration.routesById.liveReceptionistScripts.url;
        self.modelStateObserver = null;
        self.portalScriptId = ko.observable('').extend({observeState: true});
        self.hasWarningMessages = ko.observable(false);
        self.liveReceptionistPortalScriptId = ko.observable("");
        self.liveReceptionistPortalScriptUrl = ko.observable("");
        self.isRouteToDirty = ko.observable(false);
        self.validationWarningMessages = ko.observableArray([]);

        self.isImpersonating = ko.pureComputed(() => {
            return _sessionAccountInfo.isImpersonating();
        });

        self.selectedType = ko.observable(LiveReceptionistScriptTypeConstants.LiveReceptionist.toString()).extend({observeState: true});
        self.availableTypes = [
            {id: LiveReceptionistScriptTypeConstants.LiveReceptionist.toString(), text: _i18n.t('addLiveReceptionistScript:types.liveReceptionist')},
            {id: LiveReceptionistScriptTypeConstants.WebChat.toString(), text: _i18n.t('addLiveReceptionistScript:types.webChat')},
            {id: LiveReceptionistScriptTypeConstants.OutboundCalling.toString(), text: _i18n.t('addLiveReceptionistScript:types.outboundCalling')}
        ];

        self.headerI18nKey = ko.observable("associateLiveReceptionistScript:associateHeader");
        self.saveButtonTitle = ko.observable(_i18n.t('associateLiveReceptionistScript:save'));

        self.showOpenInPortalLink = ko.pureComputed(() => {
            return self.isImpersonating();
        });

        self.forceValidation = () => {
            return _promiseFactory.defer((validatePromise) => {
                _validator.validate()
                    .fail(validatePromise.reject)
                    .done((isValid) => {
                        validatePromise.resolve(isValid);
                    });
            });
        };

        self.save = () => {
            return _promiseFactory.deferWithMinimumWait((promise) => {
                self.forceValidation()
                    .fail(promise.reject)
                    .done((isValid) => {
                        if (!isValid) {
                            promise.resolve();
                        } else {
                            self.validationWarningMessages.removeAll();
                            self.hasWarningMessages(false);
                            _associateLiveReceptionistScript()
                                .fail(promise.reject)
                                .done((response) => {
                                    if (response.isSuccessful === false) {
                                        self.validationWarningMessages.push({message: response.failureReason, listItems: []});
                                        self.hasWarningMessages(true);
                                    } else {
                                        self.modelStateObserver.saveData();
                                        _router.navigate(self.liveReceptionistScriptsUrl);
                                    }

                                    promise.resolve();
                                });
                        }
                    });
            });
        };

        self.cancelForm = () => {
            return _promiseFactory.defer((promise) => {
                self.modelStateObserver.navigateWithoutWarning = true;
                _router.navigate(self.liveReceptionistScriptsUrl);
                promise.resolve();
            });
        };

        self.openInLiveReceptionistPortal = () => {
            _windowControl.openNewWindow(self.liveReceptionistPortalScriptUrl());
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/liveReceptionistScripts/facades/associateLiveReceptionistScriptFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ValidatorConstructor = require('presentation/settings/liveReceptionistScripts/validators/associateLiveReceptionistScriptViewModelValidator');
            _validator = new ValidatorConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _validator.registerViewModel(self, _facade);
            self.modelStateObserver = new ModelStateObserverConstructor(self, true);
            self.modelStateObserver.commitData();
            return _promiseFactory.wait();
        };
    };
});
